import { LocalStorageService } from '../services/local-storage-service';

const countryLocalStorageKey = 'v3-countries';
const stateLocalStorageKey = 'v3-states';
const stateLocalStorageVersion = '2-27-20';

class CountryServiceClass {
  getCountriesFromLocalStorage() {
    return LocalStorageService.getItem(countryLocalStorageKey);
  }

  getStatesFromLocalStorage() {
    return LocalStorageService.getItem(`${stateLocalStorageKey}-${stateLocalStorageVersion}`);
  }

  clearOldStatesIfExists() {
    LocalStorageService.clearItemsWithPrefix(stateLocalStorageKey);
  }

  writeCountriesToLocalStorage(countries) {
    if (!countries) {
      return;
    }
    return LocalStorageService.setItem(countryLocalStorageKey, countries);
  }

  writeStatesToLocalStorage(states) {
    if (!states) {
      return;
    }
    this.clearOldStatesIfExists();
    return LocalStorageService.setItem(`${stateLocalStorageKey}-${stateLocalStorageVersion}`, states);
  }
}

export const CountryService = new CountryServiceClass();
